<div class="availability-card">
  <div
    class="label-content"
    [class.available]="availableState() === 'NOW'"
    [class.reserve]="availableState() === 'SOON'"
    [class.not-available]="availableState() === 'UNAVAILABLE'"
  >
    <div class="text">
      <p class="availability">
        @if (availableState() === 'NOW') {
          <span class="availability__top">
            {{ translation.common.available | transloco | lowercase }}
          </span>
          <span class="availability__bottom">
            {{ translation.common.now | transloco | lowercase }}
          </span>
        }
        @if (availableState() === 'SOON') {
          <span class="availability__top">
            {{ translation.common.available | transloco | lowercase }}
          </span>
          <span class="availability__bottom">
            {{ translation.common.onLater | transloco | lowercase }}
          </span>
        }
        @if (availableState() === 'UNAVAILABLE') {
          <span class="availability__top">
            {{ translation.common.not_available | transloco | lowercase }}
          </span>
        }
      </p>
    </div>
  </div>

  @if (availableState() !== 'UNAVAILABLE') {
    <div class="date-time">
      <div [class]="availableState() !== 'UNAVAILABLE' ? 'from' : 'from-red'">
        <div class="square"></div>
        <div class="text">
          <span class="date">{{ from() | dateFormat }}</span>
          <p class="time">{{ from() | timeFormat }}</p>
          <div class="state">
            {{ translation.leftMenu.from | transloco }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="to">
        <div class="square"></div>
        <div class="text">
          <span class="date">{{ to() | dateFormat }}</span>
          <p class="time">{{ to() | timeFormat }}</p>
          <div class="state">
            {{ translation.leftMenu.to | transloco }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
